import { updateCell } from "./update-cell";

export function clearRowHover(scenegraph, colOrigin, row, selectRanges, selectMode) {
    const table = scenegraph.table;
    for (let col = 0; col < table.colCount; col++) updateCell(scenegraph, col, row);
    return !0;
}

export function updateRowHover(scenegraph, colOrigin, row, selectRanges, selectMode, singleStyle) {
    const table = scenegraph.table;
    for (let col = 0; col < table.colCount; col++) updateCell(scenegraph, col, row);
    return !0;
}
//# sourceMappingURL=row.js.map
